module.exports = __webpack_public_path__ + "static/new-machine-service-role-template-c793118284536fce0a5d7e0a4b65c59b.png";